const TrophyLogo = ({ className }: { className: string }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      width="48"
      height="48"
      rx="24"
      fill="#35342F"
    />
    <path
      d="M28.6555 30.9231H19.3445M28.6555 30.9231C30.3696 30.9231 31.7591 32.3007 31.7591 34H16.2409C16.2409 32.3007 17.6304 30.9231 19.3445 30.9231M28.6555 30.9231V27.4615C28.6555 26.8243 28.1344 26.3077 27.4916 26.3077H26.5899M19.3445 30.9231V27.4615C19.3445 26.8243 19.8656 26.3077 20.5084 26.3077H21.4101M26.5899 26.3077H21.4101M26.5899 26.3077C26.0236 25.3373 25.6651 24.2328 25.5745 23.0541M21.4101 26.3077C21.9764 25.3373 22.3349 24.2328 22.4255 23.0541M17.0168 16.0373C16.0005 16.1838 14.9946 16.3618 14 16.5703C14.4659 19.3061 16.7529 21.4285 19.5821 21.6695M17.0168 16.0373V16.3077C17.0168 18.4695 18.0163 20.3999 19.5821 21.6695M17.0168 16.0373V14.483C19.2984 14.1646 21.6298 14 24 14C26.3702 14 28.7016 14.1646 30.9832 14.483V16.0373M19.5821 21.6695C20.3969 22.3301 21.365 22.8118 22.4255 23.0541M30.9832 16.0373V16.3077C30.9832 18.4695 29.9837 20.3999 28.4179 21.6695M30.9832 16.0373C31.9995 16.1838 33.0054 16.3618 34 16.5703C33.5341 19.3061 31.2471 21.4285 28.4179 21.6695M28.4179 21.6695C27.6031 22.3301 26.635 22.8118 25.5745 23.0541M25.5745 23.0541C25.0685 23.1697 24.5414 23.2308 24 23.2308C23.4586 23.2308 22.9315 23.1697 22.4255 23.0541"
      stroke="#EEECE8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default TrophyLogo
